import { api } from './authService';

export interface NFEntry {
  numero: string;
  numero_int: number | null;
  date: string;
  payee: string;
  competencia: string;
  data_competencia?: string;
  emitida_em: string;
  tomador_cnpj: string;
  tomador_nome: string;
  valor_bruto: number | null;
  valor_liquido: number | null;
  iss_retido: string;
  municipio_incidencia: string;
  cod_tributario: string;
  nsu?: string;
  status?: string;  // "" | "pendente" | "cancelada"
  cancelada_em?: string;
  cancela_motivo?: string;
  doc_key: string;
  txn_id: string;
}

export interface NFListResponse {
  nfes: NFEntry[];
  gaps: number[];
  first_numero: number | null;
  last_numero: number | null;
  total: number;
}

export async function listNFes(): Promise<NFListResponse> {
  const res = await api.get<NFListResponse>('/nfes');
  return res.data;
}

export interface SefazStatus {
  cursor: string;
  sync_count: number;
  last_sync_raw: string;
  cert_path_set: boolean;
  cert_pass_set: boolean;
  cnpj: string;
}

export interface SefazSyncResult {
  status: string;
  cursor_before: string;
  cursor_after: string;
  docs_found: number;
  docs_new: number;
  docs_skipped: number;
  errors: string[];
  created_txns: { numero: string; date: string; payee: string; doc_key: string }[];
}

export async function getSefazStatus(): Promise<SefazStatus> {
  const res = await api.get<SefazStatus>('/sefaz/nfse/status');
  return res.data;
}

export async function runSefazSync(force_from_zero = false): Promise<SefazSyncResult> {
  const res = await api.post<SefazSyncResult>('/sefaz/nfse/sync', {
    force_from_zero,
    max_batches: 20,
  });
  return res.data;
}
